import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { PriorityCalls } from './PriorityCalls';
import { PriorityCallsList } from './PriorityCallsList';

const Priority = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <PriorityCalls />
            <PriorityCallsList />
        </>
    );
};

export default Priority;
